module.exports = __webpack_public_path__ + "static/media/person1.c542bf58.jpeg";